function cronometro(inicio, actual) {
    // var actual = 1590514670152;
    // var inicio = 1590514257491;

    let diff=new Date(actual-inicio);

    // mostramos la diferencia entre la fecha actual y la inicial
    // let result=LeadingZero(diff.getUTCHours())+":"+LeadingZero(diff.getUTCMinutes())+":"+LeadingZero(diff.getUTCSeconds());

    let s = diff.getUTCSeconds();
    let m = diff.getUTCMinutes();
    // var h = diff.getUTCHours();              

    let msec = actual-inicio;
    let h = Math.floor(msec / 1000 / 60 / 60);

    let cronometro = "";

    if (s === 60) { m++; s = 0; }
    if (m === 60) { h++; s = 0; m = 0; }
    if (h < 10) {cronometro += "0" + h + ":"; }else{ cronometro += h + ":";}
    if (m < 10) {cronometro += "0" + m + ":"; }else {cronometro +=  m + ":";}
    if (s < 10) {cronometro += "0" + s + ""; }else {cronometro +=  s + "";}

    return cronometro;
}


function pwStrong(inputtxt) { 
    var passw = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@!#$*_-]).{6,20}$/;
    if( inputtxt.match(passw) )  { 
        return true;
    } else { 
        return false;
    }
}

export { cronometro, pwStrong }